"use client";
const a = {
  text: "",
  email: "",
  checkbox: !1,
  textarea: "",
  file: void 0,
  // file inputs are always uncontrolled since their value can only be set by the user so it's ok to use undefined here
  select: ""
};
function n(u) {
  return u ? u?.reduce((t, e) => ("defaultValue" in e && e.defaultValue ? t[e.name] = e.defaultValue : e.inputType && (t[e.name] = a[e.inputType]), t), {}) : {};
}
export {
  a as defaultInputValues,
  n as getFormDefaultValues
};
